import { MyAccountOrdiniDetail } from 'components/organisms'
import React from 'react'

const MyAccountOrdiniDetailTemplate = ({ ordine }) => {
  return <MyAccountOrdiniDetail ordine={ordine} />
}

export default MyAccountOrdiniDetailTemplate
